import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export const useOnlineContractPaymentSave = () =>
  useMutation<any, any, { contractId: number; amount: number; currencyId: number }>(async data => {
    const res = await $api.post('/v1/online-contract/payment', data);

    return res?.data;
  });
